export const sidebarWidth = 256;
export const sidebarWidthCollapsed = 80;
export const headerHeight = 81;
export const sideBarIconSize = 18;
